import authorization from 'live/services/authorization'

export const hasPermission =
    authorization.superAdmin ||
    authorization.Permission.ENV_PROPERTIES_ADMIN